import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import ArticuloGestion from './view/ArticuloGestion'

const ArticuloRegistroApp = Loadable(lazy(() => import('./view/ArticuloRegistro')))
const ArticuloActualizarApp = Loadable(lazy(() => import('./view/ArticuloActualizar')))
const ArticuloComplementoApp = Loadable(lazy(() => import('./view/ArticuloComplemento')))
const ArticuloComplementoRegistroApp = Loadable(lazy(() => import('./view/ArticuloComplementoRegistro')))

export const articuloRoutesMap = {
  gestion: {
    path: '/articulo/gestion',
    name: 'Gestión de artículos',
    action: 'ARTICULOS',
  },
  registro: {
    path: '/articulo/nuevo',
    name: 'Nuevo articulo',
    action: 'ADMINISTRAR_ARTICULO',
  },
  actualizar: {
    path: '/articulo/actualizar/:id',
    name: 'Actualizar articulo',
    action: 'ADMINISTRAR_ARTICULO',
  },
  complemento: {
    path: '/articulo/complemento',
    name: 'Complementos',
    action: 'COMPLEMENTOS',
  },
  complementoRegistro: {
    path: '/articulo/complemento/upsert',
    name: 'Complemento registro',
    action: 'ADMINISTRAR_COMPLEMENTO',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloRoutes = [
  {
    path: articuloRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ArticuloRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <ArticuloActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.complemento.path,
    element: (
      <OperacionesProvider>
        <ArticuloComplementoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.complementoRegistro.path,
    element: (
      <OperacionesProvider>
        <ArticuloComplementoRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default articuloRoutes
